<template>
  <el-form ref="form" label-width="210px">
    <template v-for="item of list">
      <el-form-item v-bind:label="item.flag_desc" :key="item.id">
        <el-input
                v-focus
                v-on:blur="inputBlur(item)"
                v-if="item.editing"
                v-model="item.item_bns"
                type="textarea"
                :rows="7"
                placeholder="请输入内容">
        </el-input>
        <span class="bntext" @dblclick="boxClick(item)" v-else>{{item.item_bns}}</span>
        <span class="frm-tips">* 双击进行编辑，点击空白区域自动保存</span>
        <br />
      </el-form-item>
    </template>
  </el-form>
</template>
<script>
import {getItemsFlagSetting, setItemsFlagSetting} from '../../../../api/goods'

export default{
  data () {
    return {
      list: []
    }
  },
  methods: {
    getConfig () {
      let query = {}
      getItemsFlagSetting(query).then(response => {
        this.list = response.data.data.list
        // this.list.forEach(function (item, index, array) {
        //   console.log(item.flag_desc)
        //   console.log(index)
        //   console.log(array)
        // })
      })
    },
    boxClick (item) {
      // this.$set(this.list, editing, true)
      // console.log(this.list)
      item.editing = true
    },
    inputBlur (item) {
      item.editing = false
      console.log(item)
      setItemsFlagSetting(item).then(response => {
        this.$message({
          type: 'success',
          message: '保存成功'
        })
      })
    }
  },
  directives: {
    focus: {
      inserted: function (el) {
        el.querySelector('textarea').focus()
        // console.log(el)
        // el.focus()
      }
    }
  },
  mounted () {
    this.getConfig()
  }
}
</script>
<style>
  label {
    font-weight: 600;
  }
  div.el-textarea>textarea {
    line-height: 40px;
  }
  span.bntext {
    cursor: pointer;
    display: block;
    height: 280px;
    width: 100%;
    padding: 0 5px;
    word-break: break-all;
    overflow-y: scroll;
    border: 1px solid #eee;
  }
  span.frm-tips {
    color: #f00;
  }
</style>



// WEBPACK FOOTER //
// index.vue?f08b60aa